import { HookAPI } from 'antd/es/modal/useModal'
import classNames from 'classnames'
import { createElement } from 'react'

import { DELAY } from '@/constants'

import cn from './ModalMessage.module.scss'
import ModalMessageErrorContent from './ModalMessageErrorContent/ModalMessageErrorContent'

type ModalMessageProps = {
  title: string
  modal: HookAPI
  messageType: 'success' | 'error' | 'warning'
  error?: unknown
}

function ModalMessage(props: ModalMessageProps) {
  const { title, modal, messageType, error } = props
  const hasError = error !== undefined

  let instance = {
    destroy: () => {},
  }

  const modalSettings = {
    title: hasError
      ? createElement(ModalMessageErrorContent, { title, error })
      : title,
    className: classNames(
      cn.modalMessage,
      hasError ? cn.withError : cn.autoClose
    ),
    centered: true,
    closable: false,
    maskClosable: true,
    keyboard: true,
    ...(hasError && {
      okText: 'Понятно',
    }),
  }

  if (messageType == 'success') {
    instance = modal.success(modalSettings)
  } else if (messageType == 'error') {
    instance = modal.error(modalSettings)
  } else if (messageType == 'warning') {
    instance = modal.warning(modalSettings)
  }

  if (hasError) return

  setTimeout(() => {
    instance.destroy()
  }, DELAY * 3)
}

export default ModalMessage
